export default __webpack_public_path__ + "media/convenience_product_2.ddc25ed1.png";